import { render, staticRenderFns } from "./JobTranscriptions.vue?vue&type=template&id=646c047a&scoped=true&"
import script from "./JobTranscriptions.vue?vue&type=script&lang=js&"
export * from "./JobTranscriptions.vue?vue&type=script&lang=js&"
import style0 from "./JobTranscriptions.vue?vue&type=style&index=0&id=646c047a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646c047a",
  null
  
)

export default component.exports